import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export function HcHeader({ title, back, right, onBack }) {
    const nav = useNavigate();
    return (
        <div className="flex items-center gap-3 px-5 pb-3 pt-1">
            <button aria-label="Back" data-testid="hc-back" onClick={() => (onBack ? onBack() : back ? nav(back) : nav(-1))} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white text-navy shadow-sm transition-transform active:scale-90"><ChevronLeft size={20} /></button>
            <h1 className="min-w-0 flex-1 truncate font-heading text-xl font-extrabold text-navy" data-testid="hc-page-title">{title}</h1>
            {right}
        </div>
    );
}

export function HcEmergency() {
    return (
        <p data-testid="hc-emergency-notice" className="rounded-2xl border border-red-200 bg-red-50 p-3 text-[11px] leading-relaxed text-red-800">
            <b>Not for emergencies.</b> For chest pain, breathing difficulty, stroke signs, heavy bleeding or unconsciousness, call <a href="tel:112" className="font-bold underline">112</a> or go to the nearest hospital. Home visits are scheduled appointments.
        </p>
    );
}
